import { render, staticRenderFns } from "./RelacaoContratacoesEntregasFiltro.vue?vue&type=template&id=3844f2be"
import script from "./RelacaoContratacoesEntregasFiltro.vue?vue&type=script&lang=js"
export * from "./RelacaoContratacoesEntregasFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports